import { Deal } from 'app/models/dto/deal.model';
import { LoanProduct } from 'app/models/dto/loan-product.model';
import { Offer } from 'app/services/offers/offer.model';
import { Approval } from 'ng2-app/models/dto/approval/approval.model';

export class GetDeals {
	static readonly type = '[Deals] GetDeals';
	constructor(public borrowerId: number, public refresh?: boolean) {}
}

export class CreateDeals {
	static readonly type = '[Deals] CreateDeals';
	constructor(
    public borrowerId: number,
    public userId: number,
    public loanProducts: LoanProduct[],
    public rejectedReason: { reason: string, comment: string } | null
  ) {}
}

export class CreateDeal {
	static readonly type = '[Deals] CreateDeal';
	constructor(public newDeal: any) {}
}

export class UpdateDeal {
	static readonly type = '[Deals] UpdateDeal';
	constructor(public dealId: number, public dealUpdates: any) {}
}

export class UpdateDealDetails {
	static readonly type = '[Deals] UpdateDealDetails';
	constructor(
    public dealId: number,
    public dealUpdates: Partial<Deal>,
    public ownershipChange: boolean = false,
  ) {}
}

export class FundDeal {
	static readonly type = '[Deals] FundDeal';
	constructor(public offer: Offer, public deal: Deal) {}
}

export class ClearDealStore {
	static readonly type = '[Deals] ClearDealStore';
	constructor() {}
}

/**
 * save deal status
 */
export class SaveDealStatus {
    static readonly type = '[Deals] SaveDealStatus';
    constructor(
      public dealId: number,
      public stage: string,
      public status: string,
      public reason: string,
      public otherReason: string[],
      public subReasons: string[]
    ) { }
}

/**
 * subscribe to deal status pusher channel
 */
export class SubscribeToDealStatus {
    static readonly type = '[Deals] SubscribeToDealStatus';
    constructor(public dealId: number) { }
}

export class SubscribeToDealLoopRanking {
  static readonly type = '[Deals] SubscribeToDealLoopRanking';
  constructor(
    public borrowerId: number,
  ) {}
}

/**
 * get deal status and options
 */
export class RefreshDealStatus {
    static readonly type = '[Deal] RefreshDealStatus';
    constructor(public dealId: number) { }
}

/**
 * get lender deal status
 */
export class GetLenderDealStatus {
    static readonly type = '[Deals] GetLenderDealStatus';
    constructor(public deal: Deal) { }
}

export class CreateDealContactOverride {
  static readonly type = '[Deals] CreateDealContactOverride';
  constructor(
    public dealId: number,
    public phoneCountryCode: string,
    public phone: string,
    public email: string,
    public reason: string,
  ) { }
}

export class UpdateDealContactOverride {
  static readonly type = '[Deals] UpdateDealContactOverride';
  constructor(
    public dealId: number,
    public phoneCountryCode: string,
    public phone: string,
    public email: string,
    public reason: string,
  ) { }
}

export class DeleteDealContactOverride {
  static readonly type = '[Deals] DeleteDealContactOverride';
  constructor(
    public dealId: number,
  ) { }
}

export class DealOfferAdded {
  static readonly type = '[Deals] DealOfferAdded';
  constructor(
    public offer: Offer,
  ) {}
}

export class RunDealLoopRanking {
  static readonly type = '[Deals] RunDealLoopRanking';
  constructor(
    public borrowerId: number,
  ) {}
}
